export default "__VITE_ASSET__4VLRrN22__";